import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

// 🟢 NAYA HELPER: Ye har tarah ki image (Array, Base64, ya filename) ko sahi se handle karega
const getOriginalImageUrl = (rawImage) => {
    let img = rawImage || "https://via.placeholder.com/100x100/2a201c/ffffff?text=AV";
    
    if (typeof img === 'string' && img.startsWith("[")) {
        try { img = JSON.parse(img)[0]; } catch(e) { img = img.replace(/[\[\]"]/g, ''); }
    }
    
    if (typeof img === 'string' && !img.startsWith('http') && !img.startsWith('data:image') && !img.startsWith('blob:') && !img.startsWith('/assets')) {
        img = `https://antarvaani.com/api/uploads/${img.startsWith('/') ? img.substring(1) : img}`;
    }
    
    return img;
};

const Profile = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('orders');
  const [myOrders, setMyOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const user = JSON.parse(localStorage.getItem('user'));

  // 🛡️ CHECK IF USER IS ADMIN
  const isAdmin = user?.email === 'admin@antarvaani.com' || user?.role === 'ADMIN';

  const handleLogout = () => {
      localStorage.removeItem("user");
      window.location.href = "/"; 
  };

  // --- FETCH ORDERS ---
  useEffect(() => {
    if (!user) { navigate('/login'); return; }
    
    if (isAdmin) {
        setLoading(false);
        return; 
    }

    fetchOrders();
  }, [user, navigate, isAdmin]);

  const fetchOrders = async () => {
    try {
        const response = await fetch(`https://antarvaani.com/api/orders/user/email/${user.email}`);
        if (response.ok) {
            const data = await response.json();
            setMyOrders(data);
        }
    } catch (error) { console.error(error); } 
    finally { setLoading(false); }
  };

  const handleReturnExchange = async (orderId, type) => {
    if(!window.confirm(`Confirm ${type} Request?`)) return;

    try {
        const res = await fetch(`https://antarvaani.com/api/orders/return/${orderId}`, { 
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({ type: type }) 
        });
        if(res.ok) {
            alert(`${type} Request Submitted! Our team will contact you.`);
            fetchOrders(); 
        } else {
            const msg = await res.text();
            alert("Failed: " + msg);
        }
    } catch(err) { alert("Server Error"); }
  };

  const isWithin7Days = (dateString) => {
    const orderDate = new Date(dateString);
    const today = new Date();
    const diffTime = Math.abs(today - orderDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    return diffDays <= 10; 
  };

  if (!user) return null;

  return (
    <div className="profile-page-container">
      
      {/* HEADER */}
      <div className="profile-header-section">
        <div className="profile-info-card">
            <div className="profile-avatar-circle">{user.username.charAt(0).toUpperCase()}</div>
            <div className="profile-text">
                <h1>{user.username}</h1>
                <p>{user.email}</p>
                
                {isAdmin && <span className="status-badge status-out" style={{marginBottom:'10px', display:'inline-block'}}>Administrator</span>}

                <div style={{marginTop:'10px', display:'flex', gap:'15px'}}>
                    {!isAdmin && (
                        <>
                            <button className="logout-link" style={{color: activeTab === 'orders' ? 'black' : '#888', textDecoration: activeTab === 'orders' ? 'underline' : 'none'}} onClick={() => setActiveTab('orders')}>My Orders</button>
                            <button className="logout-link" style={{color: activeTab === 'address' ? 'black' : '#888', textDecoration: activeTab === 'address' ? 'underline' : 'none'}} onClick={() => setActiveTab('address')}>Address</button>
                        </>
                    )}
                    {isAdmin && <button onClick={() => navigate('/admin')} className="logout-link" style={{color:'#1565c0', fontWeight:'bold', border:'1px solid #1565c0', padding:'5px 10px', borderRadius:'4px'}}>Go to Dashboard →</button>}
                    <button onClick={handleLogout} className="logout-link" style={{color:'#d32f2f'}}>Log Out</button>
                </div>
            </div>
        </div>
      </div>

      {/* CONTENT */}
      {!isAdmin && (
          <div className="my-orders-section">
            {activeTab === 'orders' && (
              <>
                <h2 className="section-heading">ORDER HISTORY</h2>
                {loading ? <p>Loading...</p> : myOrders.length === 0 ? <div className="no-orders"><p>No orders yet.</p><button onClick={() => navigate('/')} className="shop-now-btn">START SHOPPING</button></div> : (
                    <div className="orders-grid">
                        {myOrders.map((order, index) => (
                        <div key={index} className="order-card-premium">
                            <div className="order-header">
                                <span className="order-id">ORDER #{order.id}</span>
                                <span className={`order-status status-${order.status.toLowerCase().split(' ')[0]}`}>{order.status}</span>
                            </div>
                            
                            {/* ITEMS */}
                            <div className="order-items-preview">
                                {(() => {
                                    try {
                                        const items = JSON.parse(order.orderItems);
                                        return items.map((item, i) => (
                                            <div key={i} className="order-item-row">
                                                {/* 🟢 YAHAN SMART FUNCTION LAGAYA HAI */}
                                                <div className="item-img">
                                                    <img 
                                                        src={getOriginalImageUrl(item.image)} 
                                                        alt={item.name} 
                                                    />
                                                </div>
                                                <div className="item-details-text">
                                                    <p className="name">{item.name}</p>
                                                    <p className="meta">Size: {item.size} | Qty: {item.qty}</p>
                                                </div>
                                            </div>
                                        ));
                                    } catch (e) { return null; }
                                })()}
                            </div>

                            {/* 🚚 TRACKING INFO BOX */}
                            {order.awbNumber && (
                                <div style={{
                                    background: '#f8f9fa', 
                                    padding: '15px', 
                                    margin: '15px 0', 
                                    borderRadius: '8px', 
                                    border: '1px solid #e9ecef',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '10px'
                                }}>
                                    <div>
                                        <p style={{margin:0, fontSize:'0.75rem', color:'#888', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:'4px'}}>SHIPPED VIA {order.courierName || 'COURIER'}</p>
                                        <p style={{margin:0, fontSize:'1rem', fontWeight:'700', color:'#333'}}>AWB: {order.awbNumber}</p>
                                    </div>
                                    
                                    {order.trackingUrl && (
                                        <a 
                                            href={order.trackingUrl} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            style={{
                                                textDecoration:'none', 
                                                background:'black', 
                                                color:'white', 
                                                padding:'10px 15px', 
                                                borderRadius:'6px', 
                                                fontSize:'0.9rem', 
                                                fontWeight:'bold', 
                                                textAlign: 'center',
                                                display: 'block',
                                                width: 'fit-content'
                                            }}
                                        >
                                            Track Order ↗
                                        </a>
                                    )}
                                </div>
                            )}

                            {/* ACTION BUTTONS */}
                            <div className="order-actions-row">
                                {order.status === 'Delivered' && isWithin7Days(order.orderDate) && (
                                    <>
                                        <button className="action-btn btn-return" onClick={() => handleReturnExchange(order.id, 'Return')}>Request Return</button>
                                        <button className="action-btn btn-exchange" onClick={() => handleReturnExchange(order.id, 'Exchange')}>Exchange</button>
                                    </>
                                )}
                                
                                {order.status.includes('Return') && (
                                    <span className="return-badge">Return/Exchange Requested ⏳</span>
                                )}
                            </div>

                            <div className="order-footer">
                                <div className="order-date"><p>Ordered on: {new Date(order.orderDate).toLocaleDateString()}</p></div>
                                <div className="order-total"><span>Total:</span> Rs. {order.totalAmount}</div>
                            </div>
                        </div>
                        ))}
                    </div>
                )}
              </>
            )}

            {activeTab === 'address' && (
              <div className="order-card-premium" style={{padding:'30px', textAlign:'center'}}>
                <h3 style={{marginBottom:'10px'}}>Saved Shipping Address</h3>
                <p style={{fontSize:'1.1rem', color:'#555'}}>
                    {myOrders.length > 0 && myOrders[0].address 
                        ? `${myOrders[0].address}, ${myOrders[0].city} - ${myOrders[0].pincode}` 
                        : "No address saved yet. Place an order to save your address."}
                </p>
              </div>
            )}
          </div>
      )}
    </div>
  );
};

export default Profile;